import { Input, Radio } from "antd";
import React, { useState } from "react";
import trans from "../../utils";
import Item from "antd/es/list/Item";

export default function RadioGroup({
	item,
	preview,
	addData,
	setSubmitData,
	readOnly,
	submitData,
}) {
	const [value, setValue] = useState("");
	const [radiovalue, setRadioValue] = useState();
	const [customInput, setCustomInput] = useState("");
	const currentValue = addData
		? submitData?.find((i) => i.key === item.key)?.value ?? ""
		: item?.value ?? value ?? "";
	const handleChange = (e) => {
		setValue(e.target.value);
		if (addData) {
			setSubmitData((prev) => {
				// Remove existing item with same key if you want to replace it
				const filtered = prev?.filter((i) => i.key !== item.key) || [];
				return [
					...filtered,
					{
						key: item.key,
						name: item.name,
						title: item.title,
						value: e.target.value,
					},
				];
			});

			addData.setFieldTouched(`fields[${item.key}].value`, true);
		}
	};

	// Convert dynamic options to valid structure
	const dynamicOptions =
		Array.isArray(item?.radioOptions) &&
		item.radioOptions.length > 0 &&
		item.radioOptions.map((opt, index) => ({
			label: opt.label,
			value: opt.value,
		}));

	// Add custom "More..." option at the end
	const options = [
		...dynamicOptions,
		{
			value: "more",
			label: (
				<>
					{`${trans("More")}...`}
					{value === "more" && (
						<Input
							value={customInput}
							onChange={(e) => setCustomInput(e.target.value)}
							style={{ width: 120, marginInlineStart: 12 }}
						/>
					)}
				</>
			),
		},
	];

	return (
		<div style={item?.css}>
			<label
				htmlFor={item?.key || "radio-group"}
				className="form-label d-flex align-items-center"
				style={{
					color: item?.css?.color,
					fontFamily: item?.css?.fontFamily,
					fontSize: item?.css?.fontSize,
					fontWeight: item?.css?.fontWeight,
				}}
			>
				{item?.title}
				{item?.required?.value && radiovalue === "" && (
					<div className="text-danger ms-2">*</div>
				)}
			</label>
			<Radio.Group
				style={{ display: "flex", flexDirection: "column", gap: 8 }}
				onChange={handleChange}
				value={currentValue}
				options={options}
				disabled={readOnly}
			/>
			{preview !== true ? (
				<>
					{item?.required?.value && currentValue === "" && (
						<div className="text-danger mt-1">
							{trans(item?.required?.validationMessage)}
						</div>
					)}
				</>
			) : (
				""
			)}
		</div>
	);
}
